import TcInput from 'components/UI/form/input/TcInput';
import TcSelectReduxSearch from 'components/UI/form/input/TcSelectReduxSearch';
import TcFormItem from 'components/UI/form/TcFormItem';
import { getAllBranchesWithoutSearch } from 'redux/reducer/basicData/getAllBranchesWithoutSearch';
import { customerBranchProductGetAllStatuses } from 'redux/reducer/customerBranchProduct/customerBranchProductGetAllStatuses';
import { getCustomerProductTypes } from 'redux/reducer/ParcelOrder/getCustomerProductTypes';
import { IActors } from './globalModels';

export interface branchCustomerproductTypeList extends IActors {
  customerProductId: number;
  customerProductTitle: string;
  branchId: number;
  branchTitle: string;
  customerId: number;
  customerTitle: string;
  statusId: number;
  statusTitle: string;
  amount: number;
  decreaseAmount?: number;
  totalAmountRemaining?: number;
  id: number;
  uniqeId: number;
}

export interface branchCustomerProduct extends IActors {
  customerProductId: number;
  customerProductTitle: string;
  branchId: number;
  branchTitle: string;
  customerId: number;
  customerTitle: string;
  amount: number;
  amountAccepted: number;
  decreaseAmount: number;
  statusId: number;
  statusTitle: string;
  parcelId: number;
  returnedToInventoryAmount: number;
  totalAmountRemaining: number;
  parcelBarcode: string;
  id: number;
}

export type customerProductStatus = {
  title: string;
  id: number;
};

const filterItems = (
  <>
    <TcFormItem name='branchesId' label='نمایندگی'>
      <TcSelectReduxSearch reducerName='branch' reducerListProperty='branchList' getlist={getAllBranchesWithoutSearch} allowClear />
    </TcFormItem>
  </>
);

const filterItemsMyTab = (
  <>
    <TcFormItem name='branchesId' label='نمایندگی'>
      <TcSelectReduxSearch reducerName='branch' reducerListProperty='branchList' getlist={getAllBranchesWithoutSearch} allowClear />
    </TcFormItem>

    <TcFormItem name='statusId' label='وضعیت'>
      <TcSelectReduxSearch reducerName='customerBranchProduct' reducerListProperty='customerProductStatus' getlist={customerBranchProductGetAllStatuses} allowClear />
    </TcFormItem>
  </>
);

const inputs = () => (
  <>
    <TcFormItem label='نوع کالا' name='fCustomerProductId' rules={[{ required: true, message: 'نوع کالا را انتخاب کنید' }]}>
      <TcSelectReduxSearch reducerName='parcelOrder' reducerListProperty='customerProductTypes' getlist={getCustomerProductTypes} />
    </TcFormItem>
    <TcFormItem name='fBranchesId' label='نمایندگی' rules={[{ required: true, message: 'انتخاب نمایندگی اجباری است' }]}>
      <TcSelectReduxSearch reducerName='branch' reducerListProperty='branchList' getlist={getAllBranchesWithoutSearch} allowClear />
    </TcFormItem>
    <TcFormItem
      name='amount'
      label='تعداد'
      rules={[
        {
          required: true,
          message: 'تعداد کالا را وارد کنید',
        },
      ]}>
      <TcInput type='number' min={1} className='ant-input' placeholder='تعداد کالا' allowClear />
    </TcFormItem>
  </>
);

interface ColumnHandlers {
  handleDelete?: (_id: number | string) => void;
  handleEdit?: (_record: branchCustomerproductTypeList) => void;
}

const columns = (_handlers?: ColumnHandlers) => {
  const columns: any = [
    {
      title: 'عنوان کالا',
      key: 'customerProductTitle',
      dataIndex: 'customerProductTitle',
    },
    {
      title: 'تعداد کل قبول شده ',
      key: 'amountAccepted',
      dataIndex: 'amountAccepted',
    },
    {
      title: 'تعداد کالای سفارش داده شده',
      key: 'decreaseAmount',
      dataIndex: 'decreaseAmount',
    },

    {
      title: 'تعداد کالای باقی مانده',
      key: 'totalAmountRemaining',
      dataIndex: 'totalAmountRemaining',
    },
    {
      title: 'تعداد کالای برگشتی (ابطال)',
      key: 'returnedToInventoryAmount',
      dataIndex: 'returnedToInventoryAmount',
    },
    {
      title: 'نمایندگی',
      key: 'branchTitle',
      dataIndex: 'branchTitle',
    },
    {
      title: 'نام کاربر',
      key: 'customerTitle',
      dataIndex: 'customerTitle',
    },
  ];

  return columns;
};

const columnsMyReq = () => {
  const columns: any = [
    {
      title: 'عنوان کالا',
      key: 'customerProductTitle',
      dataIndex: 'customerProductTitle',
    },
    {
      title: 'وضعیت',
      key: 'statusTitle',
      dataIndex: 'statusTitle',
    },
    {
      title: 'بارکد مرسوله',
      key: 'parcelBarcode',
      dataIndex: 'parcelBarcode',
    },
    {
      title: 'تعداد کل درخواستی ',
      key: 'amount',
      dataIndex: 'amount',
    },
    {
      title: 'تعداد کالای کسرشده',
      key: 'decreaseAmount',
      dataIndex: 'decreaseAmount',
    },
    {
      title: 'نمایندگی',
      key: 'branchTitle',
      dataIndex: 'branchTitle',
    },
    {
      title: 'نام کاربر',
      key: 'customerTitle',
      dataIndex: 'customerTitle',
    },
  ];

  return columns;
};

const branchCustomerProductTypeModel = { columns, columnsMyReq, filterItemsMyTab, filterItems, inputs, title: ' موجودی انبار من' };

export default branchCustomerProductTypeModel;
